import React, { useState, useEffect, useRef } from 'react';
import css from "./Odometer.module.css"

const Stepper = ({ num }) => {
    // Начальное смещение (1 - настоящий ноль)
    const [currentIndex, setCurrentIndex] = useState(num + 1);
    const [isAnimating, setIsAnimating] = useState(true);
    const prevNumRef = useRef(num);

    useEffect(() => {
        if (num !== prevNumRef.current) {
            const prev = prevNumRef.current;
            let nextIndex = num + 1;

            // Логика перехода 9 -> 0 (вперед)
            if (prev === 9 && num === 0) {
                nextIndex = 11; // Едем к фейковому нулю в конце
            } 
            // Логика перехода 0 -> 9 (назад)
            else if (prev === 0 && num === 9) {
                nextIndex = 0; // Едем к фейковой девятке в начале
            }

            setIsAnimating(true);
            setCurrentIndex(nextIndex);
            prevNumRef.current = num;
        }
    }, [num]);

    const handleTransitionEnd = () => {
        // Если мы на фейковом нуле (индекс 11) - прыгаем на настоящий ноль (индекс 1)
        if (currentIndex === 11) {
            setIsAnimating(false);
            setCurrentIndex(1);
        } 
        // Если на фейковой девятке (индекс 0) - прыгаем на настоящую девятку (индекс 10)
        else if (currentIndex === 0) {
            setIsAnimating(false);
            setCurrentIndex(10);
        }
    };

    // Ряд цифр с запасом с обеих сторон
    const digits = [9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

    return (
        <div
            className={css.stepper}
            onTransitionEnd={handleTransitionEnd}
            style={{
                transform: `translateY(-${currentIndex * 1.5}rem)`,
                transition: isAnimating ? 'transform 0.5s ease-in-out' : 'none',
            }}
        >
            {digits.map((digit, i) => (
                <span key={i}>{digit}</span>
            ))}
        </div>
    );
};

export { Stepper };
